<div class="back-btn" (click)="close()"></div>
<div class="error-dialog-box">
  <p class="error-dialog-box-message">{{ message }}</p>
  <p class="error-dialog-box-code" *ngIf="errorCode">{{ 'dialog.errorCode' | translate }} {{ errorCode }}</p>
  <div class="error-dialog-box-buttons horizontal-focusable-container" data-blocked>
    <button class="primary-button focusable-element" (click)="ok()">{{ 'dialog.ok' | translate }}</button>
    <button *ngIf="showCloseButton" class="primary-button focusable-element" (click)="close()">{{ 'dialog.close' | translate }}</button>
  </div>
</div>

